import {
  confirm,
  IConfirm,
  IConfirmAction,
} from "@rentiohq/shared-frontend/dist/utils/confirm.utils";

// Shows the dialogs one after the other: each one opens once the one before
// it is answered or closed. The dashboard shows a single dialog, and a new
// one replaces the one showing, so the messages after a payment run (who was
// not billed, a link that failed) would
// otherwise hide each other. `then` runs once the last one is answered (at
// once without a dialog), e.g. to open the next owner's payment form.
export const confirmInTurn = (
  dialogs: (IConfirm | undefined)[],
  options: { show?: (dialog: IConfirm) => void; then?: () => void } = {},
): void => {
  const { show = confirm, then } = options;
  const [first, ...rest] = dialogs.filter(
    (dialog): dialog is IConfirm => dialog != null,
  );
  if (!first) {
    then?.();
    return;
  }
  if (rest.length === 0 && !then) {
    show(first);
    return;
  }
  const showRest = () => confirmInTurn(rest, { show, then });
  const thenRest = (action: IConfirmAction): IConfirmAction => ({
    ...action,
    onPress: params => {
      action.onPress?.(params);
      showRest();
    },
  });
  show({
    ...first,
    primaryActions: first.primaryActions?.map(thenRest),
    secondaryAction: first.secondaryAction
      ? thenRest(first.secondaryAction)
      : undefined,
    onClose: () => {
      first.onClose?.();
      showRest();
    },
  });
};
